'use strict';

const { resolveLayoutForPath } = require('../../../../shared/routeMatcher');

function buildFormRequestQuery({
  layouts,
  routePath,
  explicitQuery,
  searchQuery
}) {
  const baseQuery = explicitQuery
    ? Object.assign({}, explicitQuery)
    : Object.assign({}, searchQuery || {});

  const routeMatch = resolveLayoutForPath(layouts, routePath);
  return Object.assign(baseQuery, routeMatch?.params || {});
}

module.exports = {
  buildFormRequestQuery
};
